/* src/app/admin-dashboard/vm-machine/edit-channel/edit-channel.component.css */
.example-form {
  min-width: 150px;
  max-width: 500px;
  width: 100%;
}
.example-full-width {
  width: 100%;
}
.product-image {
  max-width: 100px;
  max-height: 100px;
  display: block;
}
.example-card {
  max-width: 200px;
  max-height: 100px;
  border: none !important;
}
.example-header-image {
  background-image: url(https://material.angular.io/assets/img/examples/shiba1.jpg);
  background-size: cover;
}
mat-slider {
  width: 300px;
}
.example-margin {
  margin: 0px;
}
.example-width {
  max-width: 180px;
  width: 100%;
}
.mat-mdc-slider {
  max-width: 300px;
  width: 100%;
}
::ng-deep .mat-tab-label-content {
  min-width: 25px !important;
  padding: 5px;
  font-weight: 700;
}
.mat-ink-bar {
  background-color: var(--custom-color) !important;
}
.test-channel-note {
  display: block;
  margin-top: 6px;
  color: #b3261e;
}
.theme-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
/*# sourceMappingURL=edit-channel.component.css.map */
